import Flex from 'frontend/commons/Flex'
import { DATE_KEYS } from 'frontend/constants'
import moment from 'moment'

const FlightDate = ({ date, location }) => {
  return (
    <Flex className="package-card__dynamic-content__wrapper__flight-list__records__item__details__date">
      <span className="package-card__dynamic-content__wrapper__flight-list__records__item__details__date__location">{location}</span>
      <span className="package-card__dynamic-content__wrapper__flight-list__records__item__details__date__datetime">{moment(date).utc().format(DATE_KEYS.FORMAT.FLIGHT)}</span>
    </Flex>
  )
}

export default FlightDate
